import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { CommonModule, DatePipe, TitleCasePipe } from "@angular/common";

//import { DragulaModule } from "ng2-dragula";
import { DragDropModule } from "@angular/cdk/drag-drop";

import { LunaCommonModule } from "../common/common.module";

import { CreateDashboardComponent } from "./components/create-dashboard.component";
import { ViewDashboardComponent } from "./components/view-dashboard.component";
import { EditDashboardComponent } from "./components/edit-dashboard.component";
import { AddNewWidgetComponent } from "./components/add-new-widget.component";
import { DashboardComponent } from "./components/dashboard.component";

import { WidgetComponent } from "./components/widget.component";
import { GridWidget } from "./components/widgets/grid-widget.component";
import { ChartWidget } from "./components/widgets/chart-widget.component";
import { MapWidget } from "./components/widgets/map-widget.component";

import { DashboardService } from "./services/dashboard.service";
import { DashboardResolver } from "./services/dashboard.resolver";
import { DashboardCreateResolver } from "./services/dashboard-create.resolver";
import { WorkOrderWidget } from "./components/widgets/work-order-widget.component";
import { WorkOrderService } from "../common/services/work-order.service";
import { RegistrationRequestComponent } from "./components/widgets/registration-request.component";
import { PermitsWidgetComponent } from "./components/widgets/permitting/permits-widget.component";
import { ExternalPermitWidget } from "./components/widgets/ext-permit-widget.component";
import { ExternalWorkOrderWidget } from "./components/widgets/ext-work-order-widget.component";
import { PermitService } from "../common/services/permit.service";
import { ViewDashGuardService } from '../auth/guards/view-dash-guard.service';
import { SystemPermissionGuardService } from '../auth/guards/system-permission-guard.service';
import { PipesModule } from "../common/pipes/pipes.module";
import { ScanningWidgetComponent } from './components/widgets/scanning-widget.component';
import { PendingMailWidgetComponent } from './components/widgets/pending-mail-widget.component';
import { FormControlsModule } from "../form-controls/form-controls.module";

import { InternalUpcomingBondExpirationWidget } from './components/widgets/financial-assurance/internal-upcoming-bond-expiration-widget.component';

import { FinancialAssuranceExternalWidget } from "./components/widgets/financial-assurance/fa-external-widget.component";
import { FinancialAssuranceInternalWidget } from './components/widgets/financial-assurance/fa-internal-widget.component';
import { PendingPaymentsWidgetComponent } from './components/widgets/pending-payments-widget.component';
import { WellWidgetComponent } from './components/widgets/well-widget/well-widget.component';
import { DataTableModule } from "../common/components/data-table/data-table.module";
import { WidgetExpandedViewComponent } from './components/widgets/widget-expanded-view/widget-expanded-view.component';
import { PendingWellTransferWidgetComponent } from './components/widgets/well-widget/pending-well-transfer-widget.component';
import { ChiefOrdersReportComponent } from './components/widgets/chief-orders/co-report.component';
import { OrgFilesWidget } from "./components/widgets/organization/org-files-widget.component";
import { OrganizationModule } from "../common/components/organization/organization.module";
import { WellResolver } from "../wells/resolvers/well.resolver";
import { WellTransferSellerWidgetComponent } from './components/widgets/well-widget/well-transfer-seller-widget.component';
import { GisModule } from "../gis/gis.module";
import { InspectionsInternalComponent } from './components/widgets/permitting/inspections-internal.component';
import { WellTransferBuyerWidgetComponent } from './components/widgets/well-widget/wt-buyer-widget.component';
import { ExternalPaymentsWidgetComponent } from './components/widgets/external-payments-widget/external-payments-widget.component';
import { NotificationsWidgetComponent } from './components/widgets/notifications-widget/notifications-widget.component';
import { UtilityWidgetComponent } from './components/widgets/utility-widget/utility-widget.component';
import { External7ATransferWidgetComponent } from './components/widgets/well-widget/ext-7a-transfer-widget.component';
import { IssuesWidgetComponent } from "./components/widgets/issues-widget/issues-widget.component";
import { InternalUpcomingInsuranceExpirationWidget } from "./components/widgets/financial-assurance/internal-upcoming-insurance-expiration-widget.component";
import { ExternalChiefsOrdersStatusComponent } from "./components/widgets/chief-orders/ext-chiefs-order-status.component";
import { DataCorrectionsWidgetComponent } from "./components/widgets/data-corrections-widget/data-corrections-widget.component";
import { PaperSubmissionsWidgetComponent } from './components/widgets/paper-submissions-widget/paper-submissions-widget.component';
import { DataCorrectionRequestsExternalWidgetComponent } from "./components/widgets/data-correction-requests-widgets/data-correction-requests-external-widget.component";
import { DataCorrectionRequestsInternalWidgetComponent } from "./components/widgets/data-correction-requests-widgets/data-correction-requests-internal-widget.component";
import { OrganizationManagementExternalWidgetComponent } from "./components/widgets/organization-management/organization-management-external-widget.component";
import { OrganizationManagementInternalWidgetComponent } from './components/widgets/organization-management/organization-management-internal-widget.component';
import { IssuesViewComponent } from './components/widgets/issues-view/issues-view.component';
import { ComplianceReportsInternalViewComponent } from './components/widgets/compliance-reports-internal-view/compliance-reports-internal-view.component';
import { ExternalIssuesViewComponent } from './components/widgets/external-issues-view/external-issues-view.component';
import { WellSearchViewComponent } from './components/widgets/well-search-view/well-search-view.component';
import { ComplianceReportsExternalViewComponent } from './components/widgets/compliance-reports-external-view/compliance-reports-external-view.component';
import { LandownerPassthroughViewComponent } from './components/widgets/landowner-passthrough-view/landowner-passthrough-view.component';
import { StratigraphicWellsRequiringBondingComponent } from './components/widgets/financial-assurance/stratigraphic-wells-requiring-bonding/stratigraphic-wells-requiring-bonding.component';
import { StratigraphicWellsNoBondingComponent } from './components/widgets/financial-assurance/stratigraphic-wells-no-bonding/stratigraphic-wells-no-bonding.component';
import { WellsRequiringBondingInsuranceReportComponent } from "../admin/components/reports/wells-requiring-bonding-insurance-report/wells-requiring-bonding-insurance-report";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        LunaCommonModule,
        DataTableModule,
        RouterModule,
		//DragulaModule,
		DragDropModule,
        GisModule,
        PipesModule,
        FormControlsModule,
        OrganizationModule
    ],
    declarations: [
        DashboardComponent,
        CreateDashboardComponent,
        EditDashboardComponent,
        ViewDashboardComponent,
        AddNewWidgetComponent,
        GridWidget,
        ChartWidget,
        MapWidget,
        WidgetComponent,
        WorkOrderWidget,
        RegistrationRequestComponent,
        PermitsWidgetComponent,
        ExternalChiefsOrdersStatusComponent,
        ExternalPermitWidget,
        ExternalWorkOrderWidget,
        ScanningWidgetComponent,
        PendingMailWidgetComponent,
        FinancialAssuranceExternalWidget,
        FinancialAssuranceInternalWidget,
        InternalUpcomingBondExpirationWidget,
        InternalUpcomingInsuranceExpirationWidget,
        PendingPaymentsWidgetComponent,
        WellWidgetComponent,
        WidgetExpandedViewComponent,
        PendingWellTransferWidgetComponent,        
        ChiefOrdersReportComponent,
        OrgFilesWidget,
        WellTransferSellerWidgetComponent,
        InspectionsInternalComponent,       
        WellTransferBuyerWidgetComponent,
        ExternalPaymentsWidgetComponent,
        NotificationsWidgetComponent,
        UtilityWidgetComponent,
        External7ATransferWidgetComponent,
        IssuesWidgetComponent,
        DataCorrectionsWidgetComponent,
        PaperSubmissionsWidgetComponent,
        DataCorrectionRequestsExternalWidgetComponent,
        DataCorrectionRequestsInternalWidgetComponent,
        OrganizationManagementExternalWidgetComponent,
        OrganizationManagementInternalWidgetComponent,
        IssuesViewComponent,
        ComplianceReportsInternalViewComponent,
        ExternalIssuesViewComponent,
        WellSearchViewComponent,
        ComplianceReportsExternalViewComponent,
        LandownerPassthroughViewComponent,
        StratigraphicWellsRequiringBondingComponent,
        StratigraphicWellsNoBondingComponent,
        WellsRequiringBondingInsuranceReportComponent
    ],
    exports: [
        ChiefOrdersReportComponent
    ],
    providers: [
        DashboardService,
        DashboardResolver,
        DashboardCreateResolver,
        DatePipe,
        PermitService,
        ViewDashGuardService,
        WorkOrderService,
        SystemPermissionGuardService,
        WellResolver,
        TitleCasePipe
    ]
})
export class LunaDashboardModule { }
